export const DISCLAIMER_ACCEPTED_KEY = 'immigranta:disclaimerAccepted:v1'
export const DISCLAIMER_STORAGE_EVENT = 'immigranta:disclaimer-storage'

export function hasAcceptedDisclaimer(): boolean {
  return typeof window !== 'undefined' && localStorage.getItem(DISCLAIMER_ACCEPTED_KEY) === 'true'
}

export function acceptDisclaimer(): void {
  localStorage.setItem(DISCLAIMER_ACCEPTED_KEY, 'true')
  window.dispatchEvent(new Event(DISCLAIMER_STORAGE_EVENT))
}

export function clearDisclaimerAcceptance(): void {
  if (typeof window === 'undefined') return
  localStorage.removeItem(DISCLAIMER_ACCEPTED_KEY)
  window.dispatchEvent(new Event(DISCLAIMER_STORAGE_EVENT))
}
